import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuescroll from 'vuescroll'
import VueScrollactive from 'vue-scrollactive'
import 'bootstrap'
import store from './store'
// import vuetify from './plugins/vuetify';

Vue.config.productionTip = true

Vue.use(VueScrollactive),

// Vue.use(Particles),

Vue.use(vuescroll, {
  ops: {
    // The global config
  },
  name: 'myScroll' // customize component name, default -> vueScroll
});

new Vue({
  router,
  store,

  // vuetify,
  render: h => h(App)
}).$mount('#app')
